import React, { useState } from 'react';
const faqs = [{
  q: 'Il materiale è adatto sia per Matwork che per attrezzi?',
  a: "Sì, il bundle copre il lavoro a corpo libero (Matwork) e l'integrazione con piccoli attrezzi, con principi applicabili anche ai grandi attrezzi."
}, {
  q: 'I 6 bonus sono inclusi nel prezzo di 19.90€?',
  a: "Assolutamente sì. Facendo l'ordine oggi, ricevi il pacchetto completo dei bonus senza costi aggiuntivi."
}, {
  q: 'Come ricevo il materiale?',
  a: "Subito dopo il pagamento, riceverai un'email con il link per scaricare tutti i file in formato PDF ad alta risoluzione."
}, {
  q: 'Cosa succede se ho allieve di livelli diversi nella stessa classe?',
  a: "Il bundle include progressioni e regressioni specifiche, permettendoti di adattare lo stesso esercizio a chi è all'inizio e a chi è già avanzata."
}, {
  q: 'Sono una principiante, va bene comunque per me?',
  a: 'Perfetto sia per chi inizia che per chi insegna da anni. La struttura ti dà subito sicurezza e ti accompagna passo dopo passo, senza buchi formativi.'
}, {
  q: 'Posso usarlo anche per lezioni private 1-a-1?',
  a: 'Sì. Le schede di valutazione posturale e i protocolli clinici sono progettati proprio per personalizzare le sessioni individuali al massimo livello.'
}, {
  q: 'Il pagamento è sicuro? Quali metodi posso usare?',
  a: 'Il pagamento avviene su circuito crittografato (SSL). Accettiamo carte di credito, PayPal e bonifico immediato. Nessun rinnovo automatico: è un pagamento unico.'
}, {
  q: 'Devo installare qualcosa o creare un account?',
  a: 'No. Ricevi i PDF direttamente via email. Funzionano su tablet, smartphone, PC e sono pronti per la stampa A4. Zero attriti tecnici.'
}, {
  q: 'Per quanto tempo avrò accesso al materiale?',
  a: 'Per sempre. Una volta scaricati, i file sono tuoi a vita. Nessuna scadenza, nessun abbonamento.'
}, {
  q: 'Posso davvero chiedere il rimborso entro 14 giorni?',
  a: 'Sì, senza domande. Se entro 14 giorni non senti che il tuo lavoro è diventato più semplice, scrivici e ti rimborsiamo il 100%.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-alt py-24 px-4" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main text-center mb-12 tracking-tight" data-id="element-76">
          Domande Frequenti (FAQ)
        </h2>

        <div className="space-y-4 mb-16" data-id="element-77">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-white border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/30 shadow-[0_4px_15px_rgba(201,137,155,0.05)]' : 'border-border-light hover:border-primary/20'}`} data-id="element-78">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-79">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-80">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-81">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-82">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-83">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-84">
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_8px_25px_rgba(16,185,129,0.25)]" data-id="element-85">
            👉 SÌ! VOGLIO MIGLIORARE LA MIA CARRIERA ORA
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-86">
            <span data-id="element-87">⚡ Accesso Immediato</span>
            <span data-id="element-88">•</span>
            <span data-id="element-89">🛡️ Garanzia di 14 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}